import { IconButton, Link, Stack, Tooltip } from '@mui/material';
import { ORG_SOCIAL_PLATFORM_LABELS, type OrganizationSocialLink } from '@re/shared';
import { OrgSocialPlatformIcon } from './org-social-icons';

export function SocialLinksBar({ links }: { links: OrganizationSocialLink[] }) {
  if (!links.length) return null;
  return (
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap justifyContent="center" sx={{ py: 1 }}>
      {links.map((l) => (
        <Tooltip key={l.platform} title={ORG_SOCIAL_PLATFORM_LABELS[l.platform]}>
          <IconButton
            component={Link}
            href={l.url}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            color="inherit"
            aria-label={ORG_SOCIAL_PLATFORM_LABELS[l.platform]}
          >
            <OrgSocialPlatformIcon platform={l.platform} fontSize="small" />
          </IconButton>
        </Tooltip>
      ))}
    </Stack>
  );
}
